import { atom } from 'jotai';

export const openSideBarAtom = atom(false);
